import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['pane', 'button']

  connect() {
    this.showActivePane()
  }

  switch(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const planId = button?.dataset?.planId
    if (!planId) return

    this.showPaneForPlanId(planId, button)
  }

  showActivePane() {
    const activeButton = this.buttonTargets.find((btn) => btn.classList.contains('active'))
    if (activeButton) {
      const planId = activeButton.dataset.planId
      if (planId) this.showPaneForPlanId(planId, activeButton)
      return
    }

    if (this.paneTargets.length > 0) {
      const firstPane = this.paneTargets[0]
      const firstButton = this.buttonTargets[0]
      const planId = firstPane.dataset.planId || firstPane.id.replace('plan-content-', '')
      if (planId) this.showPaneForPlanId(planId, firstButton ?? null)
    }
  }

  findPaneByPlanId(planId) {
    let pane = this.paneTargets.find((p) => p.dataset.planId === planId)
    if (!pane) {
      pane = this.paneTargets.find((p) => p.id.replace('plan-content-', '') === planId)
    }
    return pane ?? null
  }

  showPaneForPlanId(planId, activeButton = null) {
    const targetPane = this.findPaneByPlanId(planId)
    if (!targetPane) return

    this.paneTargets.forEach((pane) => {
      pane.classList.remove('active', 'show')
      pane.style.display = 'none'
    })
    targetPane.classList.add('active', 'show')
    targetPane.style.display = 'block'

    this.buttonTargets.forEach((btn) => {
      btn.classList.remove('active')
      btn.setAttribute('aria-selected', 'false')
    })
    if (activeButton) {
      activeButton.classList.add('active')
      activeButton.setAttribute('aria-selected', 'true')
    }
  }
}
